import { render, staticRenderFns } from "./luxury.vue?vue&type=template&id=449a753d&scoped=true&"
import script from "./luxury.vue?vue&type=script&lang=js&"
export * from "./luxury.vue?vue&type=script&lang=js&"
import style0 from "./luxury.vue?vue&type=style&index=0&id=449a753d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a753d",
  null
  
)

export default component.exports